import { ITheme, IStyle, mergeStyleSets, getTheme } from '@fluentui/react';
import React from 'react';
import { ICustomerInvoiceModel } from '../../../../entities-generated/models/project/customer-invoice-model';
import { BwjCard } from '../../../../framework/components/bwj-layout';
import { formatString } from '../../../../framework/utils';
import { sum } from '../../../../framework/utils/collection';

interface IReceiptSummaryProps {
  receipt: ICustomerInvoiceModel;
}

const getStyleClasses = (theme: ITheme) => {
  const checkoutSummary: IStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    flexWrap: 'nowrap',
    gap: '0.75em',
    width: '100%',
    listStyleType: 'none',
    margin: 0,
    padding: 0,
  };

  const checkoutSummaryLineItem: IStyle = {
    display: 'block',
  };

  const checkoutSummaryLineItemContent: IStyle = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',

    '& > label': {
      fontWeight: 'bold',
    },
  };

  const checkoutSummarySubtotal: IStyle = {
    ...checkoutSummaryLineItem,
    borderTop: `1px solid ${theme.palette.neutralTertiary}`,
    paddingTop: '0.25em',
  };

  const checkoutSummaryBottomLine: IStyle = {
    ...checkoutSummaryLineItem,
    borderTop: `2px solid ${theme.palette.neutralPrimary}`,
    paddingTop: '0.25em',
  };

  return mergeStyleSets({
    checkoutSummary,
    checkoutSummaryLineItem,
    checkoutSummaryLineItemContent,
    checkoutSummarySubtotal,
    checkoutSummaryBottomLine,
  });
};

export const ReceiptSummary: React.FunctionComponent<IReceiptSummaryProps> = (props) => {
  const theme = getTheme();
  const cs = getStyleClasses(theme);
  const { receipt } = props;

  return (
    <BwjCard>
      <ul className={cs.checkoutSummary}>
        {receipt.discounts.length > 0 && <>
        <li className={cs.checkoutSummarySubtotal}>
          <div className={cs.checkoutSummaryLineItemContent}>
            <label>{'Retail subtotal'}</label>
            <span>{formatString('{value:c#.2-USD}', { value: receipt.retailSubtotal / 100 }).formattedString}</span>
          </div>
        </li>
        <li className={cs.checkoutSummaryLineItem}>
          <div className={cs.checkoutSummaryLineItemContent}>
            <label>{'Discounts'}</label>
            <span>{formatString('({value:c#.2-USD})', { value: sum(receipt.discounts, d => d.total) / 100 }).formattedString}</span>
          </div>
        </li>
        </>}
        <li className={cs.checkoutSummarySubtotal}>
          <div className={cs.checkoutSummaryLineItemContent}>
            <label>{'Subtotal'}</label>
            <span>{formatString('{value:c#.2-USD}', { value: receipt.subtotal / 100 }).formattedString}</span>
          </div>
        </li>
        <li className={cs.checkoutSummaryLineItem}>
          <div className={cs.checkoutSummaryLineItemContent}>
            <label>{'Sales tax'}</label>
            <span>{formatString('{value:c#.2-USD}', { value: receipt.tax / 100 }).formattedString}</span>
          </div>
        </li>
        <li className={cs.checkoutSummaryBottomLine}>
          <div className={cs.checkoutSummaryLineItemContent}>
            <label>{'Total'}</label>
            <strong>{formatString('{value:c#.2-USD}', { value: receipt.total / 100 }).formattedString}</strong>
          </div>
        </li>
      </ul>
    </BwjCard>
  );
};
